
export default `mutation UpdateCustomer ($customerInput: CustomerInput!) {
  Bcame_set_profiling (input: $customerInput)
}`
